//modules
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, Subject, of } from 'rxjs';



@Injectable({
    providedIn: 'root',
})

export class PagesGuard {

    bussinessAccountStatus: string

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    constructor(private _router: Router) {
    }



    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        return of(true);

        // // Subscribe To The User state to get account status
        // this.bussinessAccountStatus = localStorage.getItem('ACCOUNT_STATUS');

        // if (this.bussinessAccountStatus === 'ACTIVE') {
        //     // If status is ACTIVE, redirect to home for trying to go to 'getting-started' route
        //     return of(true);

        // } else {
        //     this._router.navigate(['/getting-started']);
        //     return of(false);
        // }
    }
}
